import { Module, MutationTree, ActionTree, GetterTree, Mutation } from "vuex";
import { modelRequiredCommon } from "@/models/outbounds/requiredQuick";

export class RegistryState {
  public registrySender: outbound.registry.pin = {
    name: "",
    phoneNumber: "",
    jibunAddress: "",
    roadAddress: "",
    detailAddress: "",
    dongName: "",
    postalCode: "",
    latitude: 0,
    longitude: 0,
    pickupTime: "",
    phoneValidate: false,
  };
  public registryReceiver: outbound.registry.pin = {
    name: "",
    phoneNumber: "",
    jibunAddress: "",
    roadAddress: "",
    detailAddress: "",
    dongName: "",
    latitude: 0,
    longitude: 0,
    pickupTime: "",
    postalCode: "",
    phoneValidate: false,
  };
  public policy: boolean = false;
  public registryType: outbound.registry.type = "registeredMail";

  public customFields: outbound.customFields[] = [];

  public registryClientComment: string = "";
  public validatePopup: boolean = false;
  public receptionTimePopup: boolean = false;
  public mailCharge: outbound.registry.chargeType = {
    charge: "-",
    chargeUuid: "",
  };

  //유효성 검증 여부만 boolean으로 확인
  public validationInfo: required.common = new modelRequiredCommon();
}

const Mutations: MutationTree<RegistryState> = {
  updateRegistrySender(state: RegistryState, payload: outbound.registry.pin) {
    state.registrySender = payload;
  },
  updateRegistryReceiver(state: RegistryState, payload: outbound.registry.pin) {
    state.registryReceiver = payload;
  },
  updateRegistryPolicy(state: RegistryState, payload: boolean) {
    state.policy = payload;
  },

  updateRegistryType(state: RegistryState, payload: outbound.registry.type) {
    state.registryType = payload;
  },

  updateRegistryClientComment(state: RegistryState, payload: string) {
    state.registryClientComment = payload;
  },
  updateValidatePopup(state: RegistryState, payload: boolean) {
    state.validatePopup = payload;
  },
  updateReceptionTimePopup(state: RegistryState, payload: boolean) {
    state.receptionTimePopup = payload;
  },
  updateRegistryReceiverPhoneNumber(state: RegistryState, payload: string) {
    state.registryReceiver.phoneNumber = payload;
  },
  updateRegistrySenderPhoneNumber(state: RegistryState, payload: string) {
    state.registrySender.phoneNumber = payload;
  },
  updateRegistryCharge(
    state: RegistryState,
    payload: outbound.registry.chargeType
  ) {
    state.mailCharge = payload;
  },
  updateValidateInfo(state: RegistryState, payload: required.common) {
    state.validationInfo = payload;
  },

  resetValidateInfo(state: RegistryState, payload: required.common) {
    state.validationInfo = payload;
  },
  updateCustomFields(state: RegistryState, payload: outbound.customFields[]) {
    state.customFields = payload;
  },
};
const Actions: ActionTree<RegistryState, any> = {
  updateRegistrySender({ commit }, payload: outbound.registry.pin) {
    commit("updateRegistrySender", payload);
  },
  updateRegistryReceiver({ commit }, payload: outbound.registry.pin) {
    commit("updateRegistryReceiver", payload);
  },
  updateRegistryType({ commit }, payload: string) {
    commit("updateRegistryType", payload);
  },
  updateRegistryPolicy({ commit }, payload: boolean) {
    commit("updateRegistryPolicy", payload);
  },

  updateRegistryClientComment({ commit }, payload: string) {
    commit("updateRegistryClientComment", payload);
  },
  actionValidatePopup({ commit }, payload: boolean) {
    commit("updateValidatePopup", payload);
  },
  actionReceptionTimePopup({ commit }, payload: boolean) {
    commit("updateReceptionTimePopup", payload);
  },
  updateRegistryReceiverPhoneNumber({ commit }, payload: string) {
    commit("updateRegistryReceiverPhoneNumber", payload);
  },

  updateRegistryCharge({ commit }, payload: outbound.registry.chargeType) {
    commit("updateRegistryCharge", payload);
  },
  updateValidateInfo({ commit }, payload: required.common) {
    commit("updateValidateInfo", payload);
  },

  resetValidateInfo({ commit }) {
    commit("resetValidateInfo", new modelRequiredCommon());
  },
  updateCustomFields({ commit }, payload: outbound.customFields[]) {
    commit("updateCustomFields", payload);
  },
};
const Getters: GetterTree<RegistryState, any> = {
  getValidateInfo: (state: RegistryState) => (): required.common => {
    return state.validationInfo;
  },
  getReceptionTimePopup: (state: RegistryState) => (): boolean => {
    return state.receptionTimePopup;
  },
  getCustomFields: (state: RegistryState) => (): outbound.customFields[] => {
    return state.customFields;
  },
  getPolicy: (state: RegistryState) => (): boolean => {
    return state.policy;
  },
  getRegistryType: (state: RegistryState) => (): outbound.registry.type => {
    return state.registryType;
  },
  getRegistryReceiverPhone: (state: RegistryState) => (): string => {
    return state.registryReceiver.phoneNumber;
  },
};

const module: Module<RegistryState, any> = {
  namespaced: true,
  state: new RegistryState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
